import { useMemo, useContext } from "react";
import { ISSUE_COLUMN_KEYS } from "./columnKeys";
import { useAllColumnDefinitions } from "./useAllColumnDefinitions";
import {
  useFeatureFlag,
  FeatureFlag,
} from "@adsk/acc-issues-core/utils/featureFlags";
import { DeletedIssuesSpaceContext } from "@adsk/acc-issues-core/providers/DeletedIssuesSpaceContext";

export const useTableColumns = () => {
  const allColumns = useAllColumnDefinitions();
  const { value: showAttachmentsCountInIssuesTable } = useFeatureFlag(
    FeatureFlag.Attachment1_1IssuesTableColumn
  );
  const { value: showReferenceCountInIssuesTable } = useFeatureFlag(
    FeatureFlag.ShowReferenceCountInIssueTable
  );
  const isDeletedSpaceActive = useContext(DeletedIssuesSpaceContext);

  return useMemo(() => {
    const selectedColumnIds = [
      "select",
      ISSUE_COLUMN_KEYS.ID,
      ISSUE_COLUMN_KEYS.TITLE,
      ISSUE_COLUMN_KEYS.STATUS,
      ISSUE_COLUMN_KEYS.ISSUE_TYPE_CATEGORY,
      ISSUE_COLUMN_KEYS.ISSUE_TYPE,
      ISSUE_COLUMN_KEYS.DESCRIPTION,
      ISSUE_COLUMN_KEYS.ASSIGNED_TO,
      isDeletedSpaceActive && ISSUE_COLUMN_KEYS.DELETED_BY,
      isDeletedSpaceActive && ISSUE_COLUMN_KEYS.DELETED_ON,
      ISSUE_COLUMN_KEYS.WATCHERS,
      ISSUE_COLUMN_KEYS.COMPANY,
      ISSUE_COLUMN_KEYS.LBS_LOCATION,
      ISSUE_COLUMN_KEYS.LOCATION_DETAILS,
      ISSUE_COLUMN_KEYS.DUE_DATE,
      ISSUE_COLUMN_KEYS.START_DATE,
      ISSUE_COLUMN_KEYS.PLACEMENT,
      ISSUE_COLUMN_KEYS.ROOT_CAUSE,
      ISSUE_COLUMN_KEYS.IS_PUBLISHED,
      ISSUE_COLUMN_KEYS.CREATED_BY,
      ISSUE_COLUMN_KEYS.CREATED_AT,
      ISSUE_COLUMN_KEYS.UPDATED_BY,
      ISSUE_COLUMN_KEYS.UPDATED_AT,
      showAttachmentsCountInIssuesTable && ISSUE_COLUMN_KEYS.ATTACHMENTS,
      showReferenceCountInIssuesTable && ISSUE_COLUMN_KEYS.REFERENCES,
    ].filter(Boolean);

    return allColumns.filter(
      column => column.id && selectedColumnIds.includes(column.id)
    );
  }, [
    allColumns,
    showAttachmentsCountInIssuesTable,
    showReferenceCountInIssuesTable,
    isDeletedSpaceActive,
  ]);
};
